import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatComponentsModule } from "src/app/mat-components.module";
import { MessengerComponent } from "./messenger.component";
import { ChatroomWindowComponent } from './chatroom-window/chatroom-window.component';
import { ChatroomMessageComponent } from "./chatroom-message/chatroom-message.component";
import { ChatUserListComponent } from './chat-user-list/chat-user-list.component';
import { SignalRService } from "./services/signalr-service";
import { MessengerService } from "./services/messenger-service";
import { ChatHomeComponent } from './chat-home/chat-home.component';
import { ChatHeaderComponent } from './chat-header/chat-header.component';
import { TeamsStyleSnackbarComponent } from './teams-style-snackbar/teams-style-snackbar.component';

@NgModule({
  declarations: [
    MessengerComponent,
    ChatroomWindowComponent,
    ChatroomMessageComponent,
    ChatUserListComponent,
    ChatHomeComponent,
    ChatHeaderComponent,
    TeamsStyleSnackbarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatComponentsModule,
  ],
  exports: [
    MessengerComponent,
    ChatroomWindowComponent,
    ChatroomMessageComponent,
    ChatHomeComponent,
    ChatHeaderComponent
  ],
  providers: [
    MessengerService,
    // SignalRService
  ]
})
export class MessengerModule {}
